import { decryptData, encryptData } from "utils/dataCipherHelper";
import { instance as axios, setHeaders } from "../config/axiosInstance";

// get subscription List Api Handler
export const subscriptionListAPI = async (data) => {
  const responseData = await axios.get(
    `subcription/subscripton-list?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Survey Summary List Api Handler
export const getSurveySummaryListApi = async (data) => {
  const responseData = await axios.get(
    `survey/survey-list?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Get Survey Summary Details Api Handler
export const getSurveySummaryDetailsApi = async (data) => {
  const responseData = await axios.get(
    `survey/survey-detail?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Get Survey Summary Details Graph Data Api Handler
export const getSurveySummaryDetailsGraphApi = async (data) => {
  const responseData = await axios.get(
    `survey/survey-analysis?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Get Survey Summary Details Bar Graph Data Api Handler
export const getSurveySummaryDetailsBarGraphApi = async (data) => {
  const responseData = await axios.get(
    `survey/survey-analysis-mcq-graph?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

export const getSubscriptionLinkApi = async (data) => {
  const responseData = await axios.post(
    "payment/create-subscription",
    {
      reqData: encryptData(data),
    },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

export const invoiceListAPI = async (data) => {
  const responseData = await axios.get(
    `payment/subscription-history-list?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

export const invoiceDownloaderAPI = async (data) => {
  const responseData = await axios.get(
    `payment/invoice-downloader?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

export const cancelSubscriptionApi = async (data) => {
  const responseData = await axios.put(
    `payment/cancel-subscription`,
    {
      reqData: encryptData(data),
    },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};
